import { IUser } from '../../account/shared/account.service';

export class User implements IUser {
    id?: string;
    name?: string;

    constructor(user?: IUser) {
        if (user) {
            this.id = user.id;
            this.name = user.name;
        }
    }
}
